<template>
  <div class="app">
    <!-- 底  -->
    <footer class="footer">
      <div class="footer01">
        <div class="footer02">
          <div class="footer05">1391 0303 798</div>
          <div class=footer03>
            <img :src="require('../assets/img/f01.png')" alt="名企科技logo" />
          </div>
          <div class=footer04>
            <img :src="require('./img/wx.png')" width="95" height="95" alt="微信二维码" />
            <br>
            微信扫码咨询
          </div>
        </div>

        <div>
          <div style="display:flex;text-align: left;">
            <div class="title001">
              <div class="title002">
                主营业务
              </div>
              <div>
                <div class="dijuzhong">
                  <div style="padding:5px;">学业评测</div>
                  <div style="padding:5px;">职业评测</div>
                </div>
                <div class="dijuzhong">
                  <div style="padding:5px;">职业规划</div>
                  <div style="padding:5px;">就业指导</div>
                </div>
                <div class="dijuzhong">
                  <div style="padding:5px;">招聘人才</div>
                  <div style="padding:5px;">岗位推荐</div>
                </div>
              </div>
            </div>
            <div class="title003">
              <div class="title002">
                联系我们
              </div>
              <div>
                <div style="display: flex;justify-content: center;">
                  <div style="width: 140px;">
                    <div><img class="lianxi" src="./img/wx.png" alt="联系微信"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="title004">
              <div class="title002">
                联系电话
              </div>
              <div>
                <div class="dijuzhong" style="font-size: 25px;">
                  1391 0303 798
                </div>
              </div>
            </div>
          </div>
          <div class="di">
            <span>地址：北京西城区西直门外大街1号院2号楼19C2</span> <br>
            北京名企科技有限公司 学业评测丨职业规划 | 就业指导 <br>
            Copyright © 2017 - 2025 <span><a href="https://beian.miit.gov.cn/" target="_blank" title="京ICP备17073936号-4"
                class="huise-link">京ICP备17073936号-4</a></span> <br>
            <span>
              <img src="../assets/img/beian-icon.png" alt="公安备案图标" class="gongan">
              <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010202011134" rel="noreferrer" target="_blank"
                class="huise-link">京公网安备11010202011133号</a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      isMobile: true
    }
  },
  mounted() {
    this.checkScreenSize(); // 初始化时检查屏幕大小
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    // 移除全局点击事件监听
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768; // 根据屏幕宽度判断是否是移动端
    },
  }
}
</script>

<style scoped>
/* 底 */
.footer {
  height: 320px;
  background: #2C3E50;
  margin-top: 32px;
  z-index: 98;
  position: relative;
}

.footer01 {
  width: 1110px;
  margin: 0 auto;
}

.footer02 {
  float: left;
  width: 187px;
  color: white;
  height: 320px;
  background: #3572e5;
  text-align: center;
  line-height: 24px;
}

.footer03 {
  padding-top: 24px;
}

.footer04 {
  padding-top: 20px;
  font-size: 12px;
}

.footer05 {
  padding-top: 40px;
  color: white;
  font-weight: 700;
  font-size: 23px;
}

.white-link {
  color: white;
  text-decoration: none;
}

.di {
  margin-top: 15px;
  padding: 8px;
  font-size: 14px;
  color: white;
  line-height: 20px;
}

.title001 {
  padding: 8px;
  font-size: 16px;
  color: white;
  width: 280px;
  text-align: center;
}

.title003 {
  padding: 8px;
  font-size: 16px;
  color: white;
  width: 280px;
  text-align: center;
}

.lianxi {
  width: 70%;
}

.title004 {
  padding: 8px;
  font-size: 16px;
  color: white;
  width: 280px;
  text-align: center;
}

.title002 {
  border-bottom: 9px solid #397eff;
  font-weight: 700;
  padding-top: 15px;
  padding-bottom: 5px;
  margin-bottom: 15px;
  text-align: center;
}

.dijuzhong {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  font-size: 20px;
}

.huise-link {
  color: white;
  text-decoration: none;
}

.gongan {
  width: 16px;
  height: 17px;
  vertical-align: middle;
}

@media (max-width: 768px) {
  .footer {
    height: auto;
    margin-top: 20px;
  }

  .footer01 {
    width: 100%;
  }

  .footer02 {
    float: none;
    width: 100%;
    height: auto;
    padding: 20px 0;
  }

  .footer05 {
    padding-top: 20px;
    font-size: 18px;
  }

  .footer03 {
    padding-top: 15px;
  }

  .footer04 {
    padding-top: 15px;
  }

  .title001,
  .title003,
  .title004 {
    width: 100%;
    padding: 5px;
    font-size: 14px;
  }

  .title002 {
    font-size: 16px;
    padding-top: 10px;
    margin-bottom: 10px;
  }

  .dijuzhong {
    font-size: 14px;
    gap: 10px;
    flex-wrap: wrap;
  }

  .di {
    font-size: 12px;
    line-height: 18px;
  }

  .lianxi {
    width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue